<template>
<main class="bg-main">
  <contenthead :section="sectionData" :lesson="lessonData" :contentsData="contentsData"></contenthead>

  <div class="category_title">{{ contentOrder }}. <span class="font-jp">{{ movieData.title }}</span></div>


  <section class="container">

     <div class="heading-content-title">
      {{ $t('lesson.introduction.title') }}
    </div>

    <div class="buttons-at-the-bottom">

      <div class="player-grammar">
        <vue-plyr ref="plyr" :options="playerOptions" :key="$route.fullPath">
          <video playsinline crossorigin :data-poster="movieData.movie.poster">
            <source>
            <track kind="captions" label="Japanese" srclang="ja" :src="movieData.movie.subtitles" v-if="movieData.movie.subtitles">
            <track kind="captions" label="English" srclang="en" :src="movieData.movie.en_subtitles" v-if="movieData.movie.en_subtitles">
            <track kind="captions" label="Nepali" srclang="np" :src="movieData.movie.np_subtitles" v-if="movieData.movie.np_subtitles">
            <track kind="captions" label="Vietnamese" srclang="vn" :src="movieData.movie.vn_subtitles" v-if="movieData.movie.vn_subtitles">
            <track kind="captions" label="Thai" srclang="th" :src="movieData.movie.th_subtitles" v-if="movieData.movie.th_subtitles">
            <track kind="captions" label="Indonesian" srclang="id" :src="movieData.movie.id_subtitles" v-if="movieData.movie.id_subtitles">
            <track kind="captions" label="Spanish" srclang="es" :src="movieData.movie.es_subtitles" v-if="movieData.movie.es_subtitles">
            <track kind="captions" label="Portuguese" srclang="pt" :src="movieData.movie.pt_subtitles" v-if="movieData.movie.pt_subtitles">
            <track kind="captions" label="Korean" srclang="kr" :src="movieData.movie.kr_subtitles" v-if="movieData.movie.kr_subtitles">
            <track kind="captions" label="China" srclang="cn" :src="movieData.movie.cn_subtitles" v-if="movieData.movie.cn_subtitles">
            <track kind="captions" label="Taiwan" srclang="tw" :src="movieData.movie.tw_subtitles" v-if="movieData.movie.tw_subtitles">
            <track kind="captions" label="Russian" srclang="ru" :src="movieData.movie.ru_subtitles" v-if="movieData.movie.ru_subtitles">
            <track kind="captions" label="Ukraine" srclang="ua" :src="movieData.movie.ua_subtitles" v-if="movieData.movie.ua_subtitles">
          </video>
        </vue-plyr>
      </div>

      <div class="buttons-side-by-side">
        <a class="button button-primary button-back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary button-grammar next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

    </div>

  </section>

</main>
</template>

<script>
  import {api, appEnv } from './../../config';
  import learningLog from '../../mixins/learning-log';
  import status from '../../mixins/status';
  import {mapState} from 'vuex';
  import Hls from 'hls.js';

  import 'vue-plyr/dist/vue-plyr.css';

  import componentContentHead from '../shared/ContentHead.vue';

  export default {
    name: 'LessonMovie',
    components: {
      'contenthead': componentContentHead,
    },
    mixins: [
      learningLog,
      status
    ],
    data () {
      return {
        step: 'moviequiz',
        stepSub: 'movie',
        lessonId: null,
        contentOrder: null,
        contents_data: {},
        playerOptions: {
          controls: [
            'play-large', // The large play button in the center
            // 'restart', // Restart playback
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'captions', // Toggle captions
            'settings', // Settings menu
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen' // Toggle fullscreen
          ]
        },
        authUser: null,
        storage: {},
        initialize:false,
        hlsInstance: null,
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      contentsData() {
        return this.contents_data;
      },
      movieData() {
         return (this.$store.getters.lesson_content.moviequiz && this.$store.getters.lesson_content.moviequiz.content && this.contentOrder in this.$store.getters.lesson_content.moviequiz.content) ? this.$store.getters.lesson_content.moviequiz.content[this.contentOrder] : { movie: {}, questions: {}}
      },
    },

    async created() {
      let self = this;

      self.authUser = this.$store.getters.getAuthUser;

      self.contentOrder = this.$route.params['content_order']
      self.lessonId = this.$route.params['lesson_id']

      self.$store.dispatch("unsetSection");
      self.$store.dispatch("unsetSectionData");
      self.$store.dispatch("unsetLessonData");
      self.$store.dispatch("unsetLessonContent");
      
    },

    async mounted() {
      let self = this;

      self.$store.dispatch("showLoading", true);

      await axios.get(api.section)
      .then(async (resp) => {
        self.$store.dispatch("setSection", resp.data.section);

        let sectionSelect = null

        let secKeyList = Object.keys(self.$store.getters.section)

        for(let secKey of secKeyList) {
          let secData  = self.$store.getters.section[secKey]

          if(secData.lessons.length) {
            let lessonData = secData.lessons.find(item => {
              return item.lesson_id == self.lessonId
            })

            if(lessonData) {
              sectionSelect = secData

              self.$store.dispatch('setLessonData',  lessonData)

              self.$store.dispatch("setLessonStatus", lessonData.status);

              // Update status the first time
              if (self.$store.getters.lesson_status == 'ready') {
                self.statusLesson('start');
              }
            }
          }
        }
        if(sectionSelect) {
          self.$store.dispatch("setSectionData", sectionSelect);

          // Update status the first time
          if (sectionSelect.status == "incomplete" || sectionSelect.status == "ready") {
            self.statusSection('start');

            self.$store.dispatch("setSectionStatus", 'start');
          } else {
            self.$store.dispatch("setSectionStatus", sectionSelect.status);
          }



          await axios.get(api.lessons, {
            params: {
              section_id: self.$store.getters.section_data.section_id,
              section_status: self.$store.getters.section_status
            }
          })
          .then(async (resp) => {
            self.$store.dispatch('setLessons',  resp.data)

            await axios.get(api.contents, {
              params: {
                lesson_id: self.$store.getters.lesson_data.lesson_id,
                lesson_type: self.$store.getters.lesson_data.lesson_type
              }
            })
            .then(async (resp) => {
              self.contents_data = resp.data

              self.$store.dispatch('setLessonContent',  resp.data)

              self.$store.dispatch("showLoading", false);

              self.init();

            })
            .catch(err => {
              self.$store.dispatch("showLoading", false);
            });


          })
          .catch(err => {
            self.$store.dispatch("showLoading", false);
          });


        }
      })
    },
    
  // 以下のフックを追加
    beforeDestroy() {
      console.log('LessonMovie beforeDestroy:');
      
      // 1. vue-plyr の破棄
      if (this.$refs.plyr && this.$refs.plyr.player) {
        this.$refs.plyr.player.destroy();
      }

      // 2. hls.js の破棄 (もし hls インスタンスを保持していれば)
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
      }
    },
    
    
    methods: {
      init() {
        let self = this;
        const myVideo = document.getElementsByTagName('video')[0];
        myVideo.addEventListener('webkitbeginfullscreen webkitendfullscreen', event => {
          if(event.type === 'webkitbeginfullscreen') {
              document.documentElement.style.setProperty('--webkit-text-track-display', 'block');
          } else {
              document.documentElement.style.setProperty('--webkit-text-track-display', 'none');
          }
        });

        // Set video path
        if (Hls.isSupported() && appEnv === 'production') {
          this.hlsInstance = new Hls(); // this に保持
          this.hlsInstance.loadSource(this.movieData.movie.movie);
          this.hlsInstance.attachMedia(myVideo);
        } else {
          const source = document.getElementsByTagName('source')[0];
          source.setAttribute("src", this.movieData.movie.movie);
        }

        myVideo.load();

        const player = this.$refs.plyr.player

      },
      nextStep() {
        if (this.$store.getters.lesson_content[this.step].status != 'completed' || this.movieData.status_movie != 'completed') {
          this.statusContent('completed', this.step, { content_data_type: 'movie', content_data_order: this.contentOrder});
        }
        this.learningTempLog();
        this.learningLog();

        this.$router.push({name: 'lesson.quiz', params: { lesson_id: this.lessonId, content_order: this.contentOrder }});
      },
      back() {
        if(parseInt(this.contentOrder) > 1) {
            this.$router.push({name: 'lesson.quiz', params: { lesson_id: this.lessonId, content_order: parseInt(this.contentOrder) - 1 }});
        } else {
            return window.location.href = this.$store.getters.section_data.section_id ? `${window.global.jsl_front_url}/survival/?section_id=${this.$store.getters.section_data.section_id}` : `${window.global.jsl_front_url}/survival`
        }
      },
    },
  }
</script>

<style scoped>
/* .container {
  margin: 20px auto;
}

@media (orientation: landscape) and (max-width: 900px) {
  .container {
     max-width: 600px;
   }
} */

</style>
